var development =
    [
        {
            "id": 1,
            "title": "The Complete WordPress Website Course",
            "author": "jhon tylor",
            "email": "jhon@tylor20.gmail.com",
            "description": "Master The Complete WordPress - Build any Dynamic WordPress Website without Programming with WordPress Custom Post types",
            "level": "All",
            "lecture": 362,
            "hours": 30,
            "rating": 4.4,
            "address": {
              "street": "Kulas Light",
              "city": "Gwenborough",
              "geo": {
                "lat": "-37.3159",
                "lng": "81.1496"
              }
            },
            "phone": "1-770-736-8031 x56442",
            "website": "hildegard.org",
            "language": "English",
            "students": 4366,
            "price": 134.99,
            "image": "http://suprkit.com/assets/images/other/course-15.jpg",
          },
          {
            "id": 2,
            "title": "WordPress for Beginners - Master WordPress Quickly",
            "author": "Andraw williamson",
            "email": "Andrawwilliam20@gmail.com",
            "description": "In 2020, build a beautiful responsive Wordpress site that looks great on all devices. No experience required.",
            "level": "Beginner",
            "lecture": 220,
            "hours": 20,
            "rating": 4.6,
            "address": {
              "street": "tokyo",
              "city": "japan",
              "geo": {
                "lat": "-47.3159",
                "lng": "71.1496"
              }
            },
            "phone": "1-470-636-8231 x46442",
            "website": "Adraw.com",
            "language": "English",
            "students": 62300,
            "price": 199.99,
            "image": "http://suprkit.com/assets/images/other/course-16.jpg",
          },
          {
            "id": 3,
            "title": "CSS - The Complete Guide 2020 (incl. Flexbox, Grid & Sass)",
            "author": "Maximilian Schwarzmüller",
            "email": "maxmillian202@gmail.com",
            "description": "Learn CSS for the first time or brush up your CSS skills and dive in even deeper. EVERY web developer has to know CSS.",
            "level": "Intermediate",
            "lecture": 122,
            "hours": 20,            
            "rating": 4.7,
            "address": {
              "street": "russian",
              "city": "russia",
              "geo": {
                "lat": "-17.3159",
                "lng": "91.1496"
              }
            },
            "phone": "1-550-536-821 x2262",
            "website": "maxmillian.com",
            "language": "English",
            "students": 41668,
            "price": 99.99,
            "image": "http://suprkit.com/assets/images/other/course-12.jpg",
          },
          {
            "id": 4,
            "title": "Web Design for Beginners: Real World Coding in HTML & CSS",
            "author": "Brad schiff",
            "email": "Bradschiff30@gmail.com",
            "description": "Launch a career as a web designer by learning HTML5, CSS3, responsive design, Sass and more!",
            "level": "All",
            "lecture": 33,
            "hours": 2,            
            "rating": 4.6,
            "address": {
              "street": "ney work",
              "city": "USA",
              "geo": {
                "lat": "-47.3159",
                "lng": "21.1496"
              }
            },
            "phone": "1-570-36-8721 x22762",
            "website": "Bradsch.com",
            "language": "English",
            "students": 45120,
            "price": 129.99,
            "image": "http://suprkit.com/assets/images/other/course-18.jpg",
          },  
          {
            "id": 5,
            "title": "Landing Page Design & Conversion Rate Optimization 2018",
            "author": "Isaac rudansky",
            "email": "rudansky30@gmail.com",
            "description": "Triple Your Conversion Rate With These Landing Page Design Principles & Build A Landing Page From Scratch With No Code",
            "level": "All",
            "lecture": 104,
            "hours": 6,            
            "rating": 4.4,
            "address": {
              "street": "new work",
              "city": "USA",
              "geo": {
                "lat": "-47.3159",
                "lng": "21.1496"
              }
            },
            "phone": "1-970-36-7921 82762",
            "website": "isaac.com",
            "language": "English",
            "students": 35400,
            "price": 199.99,
            "image": "http://suprkit.com/assets/images/other/course-17.jpg",
          },   
          {
            "id": 6,
            "title": "The Complete JavaScript Course 2020: Build Real Projects!",
            "author": "Jonas Schmedtmann",
            "email": "jonas2020@gmail.com",
            "description": "Master JavaScript with the most complete course! Projects, challenges, quizzes, JavaScript ES6+, OOP, AJAX, Webpack",
            "level": "All",
            "lecture": 109,
            "hours": 10,            
            "rating": 4.8,
            "address": {
              "street": "beijing",
              "city": "Japan",
              "geo": {
                "lat": "-87.3159",
                "lng": "11.1496"
              }
            },
            "phone": "123-456-789-00",
            "website": "jonasweb.com",
            "language": "English",
            "students": 339900,
            "price": 149.99,
            "image": "https://img-a.udemycdn.com/course/480x270/1463348_52a4_2.jpg",
          }                                    
    ];

export default development;